define('home/views/AnonHomepageOverlayView',[
    'underscore',

    'core/utils',

    'home/views/common/LoginFormView',
    'home/templates/anonHomepageOverlay',
], function (
    _,

    coreUtils,
    LoginFormView,

    anonHomepageOverlayTemplate
) {
    'use strict';

    var transitionEndEvent = coreUtils.transitionEndEvent;

    /**
     * A view that shows as an overlay and contains sign up prompts and a disqus
     * sign up form.
     *
     * Since this view extends common/LoginFormView, it is a Backbone view, not a
     * Marionette view.
     */
    var AnonHomepageOverlayView = LoginFormView.extend({
        className: 'anon-homepage__overlay',
        template: anonHomepageOverlayTemplate,

        close: function () {
            var boundClose = _.bind(LoginFormView.prototype.close, this);

            if (transitionEndEvent)
                this.$el.on(transitionEndEvent, boundClose);
            else
                _.delay(boundClose, 2000);

            this.$el.addClass('is-inactive');
        },
    });

    return AnonHomepageOverlayView;
});

